(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 8526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowRightGrey(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14.828,
    viewBox: "0 0 14 14.828"
  }, props), _defs || (_defs = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("defs", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".ArrowRightGrey_svg__arrow_right_b{fill:none;stroke:#707070;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "ArrowRightGrey_svg__arrow_right_b",
    d: "M1 7.414h12M7 1.414l6 6-6 6"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowRightGrey);

/***/ }),

/***/ 37746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgAngleLeft(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.326 6.174a1.875 1.875 0 00-2.652 0l-10.5 10.5a1.875 1.875 0 000 2.652l10.5 10.5a1.875 1.875 0 102.652-2.652L16.152 18l9.174-9.174a1.875 1.875 0 000-2.652z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgAngleLeft);

/***/ }),

/***/ 75106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgRightArrow(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.116 4.116a1.25 1.25 0 011.768 0l7 7a1.25 1.25 0 010 1.768l-7 7a1.25 1.25 0 01-1.768-1.768L14.232 12 8.116 5.884a1.25 1.25 0 010-1.768z",
    fill: "#818181"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgRightArrow);

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(99800);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MarketplacePostingNudgeCards, MarketplaceListItemWithNudges */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71960);
/* harmony import */ var _vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31013);
/* harmony import */ var _vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32450);
/* harmony import */ var _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94897);
/* harmony import */ var _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94204);
/* harmony import */ var _hooks_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4641);
/* harmony import */ var _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8574);
/* harmony import */ var _hooks_useOpenNewLoadPosting__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68498);
/* harmony import */ var _posting_helpers_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40607);
/* harmony import */ var _utils_AppImg__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17073);
/* harmony import */ var _vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(10182);
/* harmony import */ var _marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98712);
/* harmony import */ var _MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(49256);
/* harmony import */ var _MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15__);


















var MarketplacePostingNudgeCard = function(param) {
    var type = param.type;
    var ValidateLorryPosting = (0,_hooks_useValidateUserStatus__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().ValidateLorryPosting;
    var loadLorryPostingConfig = (0,_context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .useLoadLorryPosting */ .NS)();
    var openNewLoadPosting = (0,_hooks_useOpenNewLoadPosting__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var sendGAandMoEngageEvent = (0,_vahak_core_dist_services_hooks_useEventTrackerService__WEBPACK_IMPORTED_MODULE_13__/* .useEventTrackerService */ .f)().sendGAandMoEngageEvent;
    var content = _marketplacePostingNudge_constants__WEBPACK_IMPORTED_MODULE_14__/* .MARKETPLACE_POSTING_NUDGE_CONTENT */ .X9[type];
    var handleClick = function() {
        if (type === "load") {
            sendGAandMoEngageEvent({
                name: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__/* .GA4EventNames.MARKET_PLACE.post_load_button_click */ .wQR.MARKET_PLACE.post_load_button_click,
                data: {
                    source_screen: "marketplace"
                }
            });
            openNewLoadPosting({
                originationPage: _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */ .ec.MARKETPLACE
            });
            return;
        }
        ValidateLorryPosting(function() {
            setTimeout(function() {
                sendGAandMoEngageEvent({
                    name: _vahak_core_dist_constants__WEBPACK_IMPORTED_MODULE_7__/* .GA4EventNames.MARKET_PLACE.add_lorry_attach_lorry_btn */ .wQR.MARKET_PLACE.add_lorry_attach_lorry_btn,
                    data: {
                        source_screen: "marketplace"
                    }
                });
                loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.updateLoadLorryPostingData({
                    isModalOpen: true,
                    category: "post",
                    originationPage: _context_load_lorry_posting__WEBPACK_IMPORTED_MODULE_9__/* .POSTING_FORM_MODAL_ORIGINATION_PAGE.MARKETPLACE */ .ec.MARKETPLACE,
                    type: "lorry"
                });
                loadLorryPostingConfig === null || loadLorryPostingConfig === void 0 ? void 0 : loadLorryPostingConfig.openLorryPostingModal(_posting_helpers_constants__WEBPACK_IMPORTED_MODULE_11__/* .LORRY_CREATION_FORM_IDS.VEHICLE_NUMBER */ .jU.VEHICLE_NUMBER);
            }, 1000);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default().main), (_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default())[type]),
        gap: 20,
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_utils_AppImg__WEBPACK_IMPORTED_MODULE_12__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, content.image), {
                unoptimized: true
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_ui_dist_layout_Flex__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                flexDirection: "column",
                gap: 20,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_MarketplacePostingNudgeCard_module_scss__WEBPACK_IMPORTED_MODULE_15___default().textWrapper),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            color: _vahak_core_ui_dist_constants_colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].WHITE */ .Z.WHITE,
                            weight: "medium",
                            align: "center",
                            mSize: "sm",
                            children: content.label
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_ui_dist_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        isRounded: true,
                        type: "button",
                        color: "tertiary",
                        blockBtn: true,
                        onClick: handleClick,
                        children: content.cta
                    })
                ]
            })
        ]
    });
};
var MarketplacePostingNudgeCards = function(param) {
    var types = param.types;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: types.map(function(type) {
            return /*#__PURE__*/ _jsx(MarketplacePostingNudgeCard, {
                type: type
            }, type);
        })
    });
};
var MarketplaceListItemWithNudges = function(param) {
    var nudgeTypes = param.nudgeTypes, showBefore = param.showBefore, showAfter = param.showAfter, children = param.children;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showBefore ? /*#__PURE__*/ _jsx(MarketplacePostingNudgeCards, {
                types: nudgeTypes
            }) : null,
            children,
            showAfter ? /*#__PURE__*/ _jsx(MarketplacePostingNudgeCards, {
                types: nudgeTypes
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MarketplacePostingNudgeCard);


/***/ }),

/***/ 98712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$d": function() { return /* binding */ LOAD_MARKETPLACE_POSTING_NUDGE_TYPES; },
/* harmony export */   "Tm": function() { return /* binding */ MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX; },
/* harmony export */   "X9": function() { return /* binding */ MARKETPLACE_POSTING_NUDGE_CONTENT; }
/* harmony export */ });
/* unused harmony exports LORRY_MARKETPLACE_POSTING_NUDGE_TYPES, MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX, getMarketplacePostingNudgeIndex, getMarketplaceNudgePlacement */
/** Nudge cards shown on load marketplace (truckers + shippers). */ var LOAD_MARKETPLACE_POSTING_NUDGE_TYPES = [
    "lorry",
    "load"
];
/** Nudge card shown on lorry marketplace (shippers). */ var LORRY_MARKETPLACE_POSTING_NUDGE_TYPES = (/* unused pure expression or super */ null && ([
    "load"
]));
var MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX = 5;
var MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX = 1;
var MARKETPLACE_POSTING_NUDGE_CONTENT = {
    load: {
        image: {
            src: "/load-icons/v1/Load.png",
            width: 70,
            height: 77
        },
        label: "Post your load to get matching lorries",
        cta: "Post Load"
    },
    lorry: {
        image: {
            src: "/lorry-icons/v3/Container.png",
            width: 156,
            height: 74
        },
        label: "Add your lorry to get matching loads",
        cta: "Post Lorry"
    }
};
function getMarketplacePostingNudgeIndex(isMobileScreen) {
    return isMobileScreen ? MARKETPLACE_POSTING_NUDGE_MOBILE_INDEX : MARKETPLACE_POSTING_NUDGE_DESKTOP_INDEX;
}
function getMarketplaceNudgePlacement(cardCount, index, nudgeIndex) {
    var isNudgePositionLast = cardCount > 0 && cardCount <= nudgeIndex && cardCount === index + 1;
    var isNudgeSlot = index === nudgeIndex || isNudgePositionLast;
    return {
        isNudgeSlot: isNudgeSlot,
        showBefore: isNudgeSlot && !isNudgePositionLast,
        showAfter: isNudgeSlot && isNudgePositionLast
    };
}


/***/ }),

/***/ 99800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../core/dist/constants/index.js + 4 modules
var constants = __webpack_require__(94204);
// EXTERNAL MODULE: ../core/dist/constants/platformStats.js
var platformStats = __webpack_require__(28230);
// EXTERNAL MODULE: ../core/dist/constants/event-names.js
var event_names = __webpack_require__(69406);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ./components/homepage-v2/compact-load-posting/CompactLoadPostingProvider.tsx + 1 modules
var CompactLoadPostingProvider = __webpack_require__(56193);
// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/useCompactLoadBidAction.ts
var useCompactLoadBidAction = __webpack_require__(36940);
// EXTERNAL MODULE: ./components/homepage-v2/hooks/useHomepageV2Translation.ts
var useHomepageV2Translation = __webpack_require__(14394);
// EXTERNAL MODULE: ./components/homepage-v2/HomepageV2.module.scss
var HomepageV2_module = __webpack_require__(94136);
var HomepageV2_module_default = /*#__PURE__*/__webpack_require__.n(HomepageV2_module);
// EXTERNAL MODULE: ./components/homepage-v2/section-card/HomepageV2SectionCard.tsx
var HomepageV2SectionCard = __webpack_require__(63968);
// EXTERNAL MODULE: ../core/dist/icons/playStoreButton.svg
var playStoreButton = __webpack_require__(98219);
// EXTERNAL MODULE: ../core/dist/icons/appStoreButton.svg
var appStoreButton = __webpack_require__(19508);
// EXTERNAL MODULE: ./components/common/download-app-qr-modal/DownloadAppAction.tsx + 1 modules
var DownloadAppAction = __webpack_require__(20058);
// EXTERNAL MODULE: ./components/homepage-v2/compactAppDownload.constants.ts
var compactAppDownload_constants = __webpack_require__(68628);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/HeroSection.module.scss
var HeroSection_module = __webpack_require__(13073);
var HeroSection_module_default = /*#__PURE__*/__webpack_require__.n(HeroSection_module);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../core/dist/icons/arrow-right-white.svg
var arrow_right_white = __webpack_require__(89905);
// EXTERNAL MODULE: ./context/RemoteConfigContext.tsx
var RemoteConfigContext = __webpack_require__(94954);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/QuoteFormCard.module.scss
var QuoteFormCard_module = __webpack_require__(30618);
var QuoteFormCard_module_default = /*#__PURE__*/__webpack_require__.n(QuoteFormCard_module);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/LoadQuoteFormFields.tsx
var LoadQuoteFormFields = __webpack_require__(77824);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/loadQuoteForm.constants.ts
var loadQuoteForm_constants = __webpack_require__(26107);
// EXTERNAL MODULE: ./components/homepage-v2/hero-section/quote-form-card/useLoadQuoteLocationForm.ts + 2 modules
var useLoadQuoteLocationForm = __webpack_require__(46473);
;// CONCATENATED MODULE: ./components/homepage-v2/hero-section/quote-form-card/QuoteFormCard.tsx












var QuoteFormCard = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, onOpenCompactPosting = param.onOpenCompactPosting, isCompactPostingOpen = param.isCompactPostingOpen, _isCompactPostingOpening = param.isCompactPostingOpening, isCompactPostingOpening = _isCompactPostingOpening === void 0 ? false : _isCompactPostingOpening;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var ref = (0,RemoteConfigContext/* useRemoteConfig */.V)(), isRemoteConfigLoaded = ref.isLoaded;
    var ref1 = (0,react.useState)({
        source: undefined,
        destination: undefined,
        lorryType: loadQuoteForm_constants/* QUOTE_FORM_LCV_LORRY_TYPE */.no,
        tonnes: ""
    }), values = ref1[0], setValues = ref1[1];
    var handleChange = (0,react.useCallback)(function(patch) {
        setValues(function(current) {
            return (0,_object_spread/* default */.Z)({}, current, patch);
        });
    }, []);
    var ref2 = (0,useLoadQuoteLocationForm/* useLoadQuoteLocationForm */.b)({
        values: values,
        onChange: handleChange,
        sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.HOME_PAGE */.ZM.HOME_PAGE,
        isRemoteConfigLoaded: isRemoteConfigLoaded,
        t: t,
        trackEvent: trackEvent,
        eventData: eventData,
        prefillFromContext: true
    }), trackAndChange = ref2.handleChange, handleLocationInput = ref2.handleLocationInput, locationMessages = ref2.locationMessages, isFormValid = ref2.isFormValid, focusFirstInvalidField = ref2.focusFirstInvalidField;
    var homeEventData = (0,react.useMemo)(function() {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, eventData), {
            source_screen: event_names/* WEB_V2_SOURCE_SCREENS.HOME_PAGE */.ZM.HOME_PAGE
        });
    }, [
        eventData
    ]);
    var handleSubmit = function(event) {
        event.preventDefault();
        if (!isFormValid) {
            focusFirstInvalidField();
            return;
        }
        trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.check_prices_clicked */.wQ.WEB_V2.check_prices_clicked, homeEventData);
        onOpenCompactPosting((0,_object_spread/* default */.Z)({}, values));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (QuoteFormCard_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (QuoteFormCard_module_default()).fields,
                onSubmit: handleSubmit,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadQuoteFormFields/* default */.Z, {
                        variant: "hero",
                        values: values,
                        labels: {
                            pickupLabel: t("homepageV2:hero.quoteForm.pickupLabel"),
                            dropLabel: t("homepageV2:hero.quoteForm.dropLabel"),
                            pickupPlaceholder: t("homepageV2:hero.quoteForm.pickupCity"),
                            dropPlaceholder: t("homepageV2:hero.quoteForm.dropCity")
                        },
                        locationMessages: locationMessages,
                        onChange: trackAndChange,
                        onPickupInputChange: function(value) {
                            return handleLocationInput("pickup", value);
                        },
                        onDropInputChange: function(value) {
                            return handleLocationInput("drop", value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "submit",
                        className: (QuoteFormCard_module_default()).cta,
                        disabled: isCompactPostingOpen || isCompactPostingOpening,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("homepageV2:hero.quoteForm.cta")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right_white/* default */.Z, {
                                className: (QuoteFormCard_module_default()).ctaIcon,
                                "aria-hidden": true
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (QuoteFormCard_module_default()).disclaimer,
                children: t("homepageV2:hero.quoteForm.disclaimer")
            })
        ]
    });
};
/* harmony default export */ var quote_form_card_QuoteFormCard = (QuoteFormCard);

;// CONCATENATED MODULE: ./components/homepage-v2/hero-section/HeroSection.tsx










var HeroSection = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, onOpenCompactPosting = param.onOpenCompactPosting, isCompactPostingOpen = param.isCompactPostingOpen, _isCompactPostingOpening = param.isCompactPostingOpening, isCompactPostingOpening = _isCompactPostingOpening === void 0 ? false : _isCompactPostingOpening;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (HeroSection_module_default()).section,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (HeroSection_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeroSection_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HeroSection_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HeroSection_module_default()).copy,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (HeroSection_module_default()).eyebrow,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("homepageV2:hero.tag.region")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (HeroSection_module_default()).eyebrowSeparator,
                                                children: "|"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: t("homepageV2:hero.tag.price")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (HeroSection_module_default()).title,
                                        children: t("homepageV2:hero.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (HeroSection_module_default()).subtitle,
                                        children: t("homepageV2:hero.subtitle")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HeroSection_module_default()).quoteFormWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(quote_form_card_QuoteFormCard, {
                                        trackEvent: trackEvent,
                                        eventData: eventData,
                                        onOpenCompactPosting: onOpenCompactPosting,
                                        isCompactPostingOpen: isCompactPostingOpen,
                                        isCompactPostingOpening: isCompactPostingOpening
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                                        className: (HeroSection_module_default()).appDownload,
                                        "aria-labelledby": "hero-app-download-title",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                id: "hero-app-download-title",
                                                className: (HeroSection_module_default()).appDownloadSeparator,
                                                children: t("homepageV2:hero.downloadApp")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (HeroSection_module_default()).storeButtons,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAppAction/* default */.Z, {
                                                        href: compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.playStoreUrl */.X.playStoreUrl,
                                                        className: (HeroSection_module_default()).storeButton,
                                                        storeUrl: compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.playStoreUrl */.X.playStoreUrl,
                                                        onClick: function() {
                                                            return trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.download_playstore */.wQ.WEB_V2.download_playstore, eventData);
                                                        },
                                                        "aria-label": t("navigation:appDownload.downloadPlayStore"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(playStoreButton/* default */.Z, {
                                                            "aria-hidden": true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadAppAction/* default */.Z, {
                                                        href: compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.appStoreUrl */.X.appStoreUrl,
                                                        className: (HeroSection_module_default()).storeButton,
                                                        storeUrl: compactAppDownload_constants/* COMPACT_APP_DOWNLOAD.appStoreUrl */.X.appStoreUrl,
                                                        onClick: function() {
                                                            return trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(event_names/* GA4EventNames.WEB_V2.download_appstore */.wQ.WEB_V2.download_appstore, eventData);
                                                        },
                                                        "aria-label": t("navigation:appDownload.downloadAppStore"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(appStoreButton/* default */.Z, {
                                                            "aria-hidden": true
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HeroSection_module_default()).right,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HeroSection_module_default()).truckFrame,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/images/homepage-v2/vahak-lcv-hero-cutout.webp",
                                    alt: t("homepageV2:hero.truckAlt"),
                                    width: 866,
                                    height: 557,
                                    draggable: false
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HeroSection_module_default()).truckBadge, " ").concat((HeroSection_module_default()).truckBadgeVerified),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (HeroSection_module_default()).badgeCheck,
                                            "aria-hidden": true,
                                            children: "✓"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: t("homepageV2:hero.truckBadges.verified")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                    children: t("homepageV2:hero.truckBadges.verifiedSubtitle")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((HeroSection_module_default()).truckBadge, " ").concat((HeroSection_module_default()).truckBadgeAvailable),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (HeroSection_module_default()).badgeLive,
                                            "aria-hidden": true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: t("homepageV2:hero.truckBadges.available")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                    children: t("homepageV2:hero.truckBadges.availableSubtitle")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var hero_section_HeroSection = (HeroSection);

// EXTERNAL MODULE: ../core-ui/dist/hooks/useMediaQuery.js
var useMediaQuery = __webpack_require__(26513);
// EXTERNAL MODULE: ./components/Swipper/Swipper.tsx
var Swipper = __webpack_require__(10169);
// EXTERNAL MODULE: ./components/homepage-v2/lorry-booking-steps/LorryBookingSteps.module.scss
var LorryBookingSteps_module = __webpack_require__(56676);
var LorryBookingSteps_module_default = /*#__PURE__*/__webpack_require__.n(LorryBookingSteps_module);
// EXTERNAL MODULE: ./components/utils/AppImg.tsx
var AppImg = __webpack_require__(17073);
// EXTERNAL MODULE: ./components/homepage-v2/animate/HomepageV2Animate.tsx
var HomepageV2Animate = __webpack_require__(16440);
;// CONCATENATED MODULE: ./components/homepage-v2/lorry-booking-steps/LorryBookingSteps.tsx








var STEP_NUMBERS = [
    "01",
    "02",
    "03",
    "04"
];
var STEP_ICONS = [
    "/homepage-v2/booking-step-11.png",
    "/homepage-v2/booking-step-12.png",
    "/homepage-v2/booking-step-13.png",
    "/homepage-v2/booking-step-14.png"
];
var LorryBookingSteps = function() {
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var stepsRaw = t("homepageV2:bookingSteps.steps", {
        returnObjects: true
    });
    var steps = Array.isArray(stepsRaw) ? stepsRaw : [];
    if (!steps.length) {
        return null;
    }
    var renderStep = function(step, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (LorryBookingSteps_module_default()).step,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (LorryBookingSteps_module_default()).stepHead,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LorryBookingSteps_module_default()).iconWrap,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppImg["default"], {
                                src: STEP_ICONS[index],
                                alt: step.title,
                                width: 24,
                                height: 24,
                                unoptimized: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (LorryBookingSteps_module_default()).stepNumber,
                            "aria-hidden": "true",
                            children: STEP_NUMBERS[index]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: (LorryBookingSteps_module_default()).stepTitle,
                    children: step.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (LorryBookingSteps_module_default()).stepDescription,
                    children: step.description
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (LorryBookingSteps_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                className: (LorryBookingSteps_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (LorryBookingSteps_module_default()).eyebrow,
                        children: t("homepageV2:bookingSteps.eyebrow")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (LorryBookingSteps_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (LorryBookingSteps_module_default()).titleLine,
                                children: t("homepageV2:bookingSteps.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (LorryBookingSteps_module_default()).titleHighlight,
                                children: t("homepageV2:bookingSteps.titleHighlight")
                            })
                        ]
                    })
                ]
            }),
            isMobileScreen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Swipper/* default */.Z, {
                className: (LorryBookingSteps_module_default()).stepsSwiper,
                cssMode: false,
                slidesPerView: 1,
                spaceBetween: 16,
                pagination: true,
                navigation: false,
                mousewheel: false,
                keyboard: false,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
                list: steps.map(function(step, index) {
                    return {
                        key: STEP_NUMBERS[index],
                        node: renderStep(step, index)
                    };
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LorryBookingSteps_module_default()).grid,
                children: steps.map(function(step, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                        variant: "fade-up",
                        delay: index * 110,
                        children: renderStep(step, index)
                    }, STEP_NUMBERS[index]);
                })
            })
        ]
    });
};
/* harmony default export */ var lorry_booking_steps_LorryBookingSteps = (LorryBookingSteps);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../core/dist/constants/routeStrings.js
var routeStrings = __webpack_require__(12098);
// EXTERNAL MODULE: ../core/dist/icons/ArrowRightGrey.svg
var ArrowRightGrey = __webpack_require__(8526);
// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/AvailableLoadsSectionV2.module.scss
var AvailableLoadsSectionV2_module = __webpack_require__(76045);
var AvailableLoadsSectionV2_module_default = /*#__PURE__*/__webpack_require__.n(AvailableLoadsSectionV2_module);
// EXTERNAL MODULE: ./services/load/useGetLoadMarketV2/useGetLoadMarketInfiniteQueryNew.ts
var useGetLoadMarketInfiniteQueryNew = __webpack_require__(68802);
// EXTERNAL MODULE: ./components/homepage-v2/available-loads-section/AvailableLoadsGrid.tsx
var AvailableLoadsGrid = __webpack_require__(11452);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
;// CONCATENATED MODULE: ./components/homepage-v2/available-loads-section/AvailableLoadsSectionV2.tsx














var AvailableLoadsSectionV2 = function(param) {
    var trackEvent = param.trackEvent, eventData = param.eventData, onBidNow = param.onBidNow;
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var isMobileScreen = (0,useMediaQuery/* default */.Z)({
        queryType: "mobile"
    });
    var maxCards = isMobileScreen ? 2 : 6;
    var ref = (0,react.useState)([]), loadsData = ref[0], setLoadsData = ref[1];
    var companyId = (0,react.useContext)(app_context/* AppContext */.Il).companyId;
    var ref1 = (0,useGetLoadMarketInfiniteQueryNew/* useGetLoadMarketInfiniteQueryNew */.Q)({
        preloads: [
            "company_detail",
            "relevancy_tags"
        ],
        l: maxCards,
        c_i: Number(companyId) || undefined
    }, {
        onSuccess: function onSuccess(data) {
            var ref;
            var ref1;
            setLoadsData((ref1 = (ref = data[0]) === null || ref === void 0 ? void 0 : ref.load_cards) !== null && ref1 !== void 0 ? ref1 : []);
        },
        onError: function onError() {}
    }), isFetched = ref1.isFetched, isFetching = ref1.isFetching;
    var visibleLoads = loadsData.slice(0, maxCards);
    var isLoading = !isFetched || isFetching && visibleLoads.length === 0;
    if (!isLoading && visibleLoads.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
        variant: "light",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AvailableLoadsSectionV2_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AvailableLoadsSectionV2_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageV2Animate/* default */.Z, {
                        variant: "fade-right",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (AvailableLoadsSectionV2_module_default()).eyebrow,
                                children: t("homepageV2:availableLoads.eyebrow")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: (AvailableLoadsSectionV2_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (AvailableLoadsSectionV2_module_default()).titleLine,
                                        children: t("homepageV2:availableLoads.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (AvailableLoadsSectionV2_module_default()).titleHighlight,
                                        children: t("homepageV2:availableLoads.titleHighlight")
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AvailableLoadsGrid/* default */.Z, {
                    loads: visibleLoads,
                    cardIdPrefix: "homepage-v2",
                    onBidNow: onBidNow,
                    isLoading: isLoading,
                    shimmerCount: maxCards
                }),
                !isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                    variant: "fade-up",
                    delay: 180,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AvailableLoadsSectionV2_module_default()).viewMoreWrap,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: routeStrings/* ROUTES.marketplace.getUrl */.Z.marketplace.getUrl("load"),
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (AvailableLoadsSectionV2_module_default()).viewMoreBtn,
                                onClick: function() {
                                    return trackEvent === null || trackEvent === void 0 ? void 0 : trackEvent(constants/* GA4EventNames.WEB_V2.view_more_loads_clicked */.wQR.WEB_V2.view_more_loads_clicked, eventData);
                                },
                                children: [
                                    t("homepageV2:availableLoads.viewMore"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightGrey/* default */.Z, {})
                                ]
                            })
                        })
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var available_loads_section_AvailableLoadsSectionV2 = (AvailableLoadsSectionV2);

// EXTERNAL MODULE: ./components/homepage-v2/app-download-banner/AppDownloadBannerV2.tsx
var AppDownloadBannerV2 = __webpack_require__(99837);
// EXTERNAL MODULE: ../core/dist/standard-icons/angle-left.svg
var angle_left = __webpack_require__(37746);
// EXTERNAL MODULE: ../core/dist/standard-icons/right-arrow.svg
var right_arrow = __webpack_require__(75106);
// EXTERNAL MODULE: ./components/homepage-v2/customer-says/CustomerSaysSection.module.scss
var CustomerSaysSection_module = __webpack_require__(11528);
var CustomerSaysSection_module_default = /*#__PURE__*/__webpack_require__.n(CustomerSaysSection_module);
;// CONCATENATED MODULE: ../core/dist/icons/star-yellow-ratings.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgStarYellowRatings(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M10.381 15.996l6.415 3.87-1.696-7.3 5.662-4.91-7.465-.64L10.38.133 7.465 7.016 0 7.656l5.663 4.91-1.698 7.3 6.416-3.87z",
    fill: "#FFB700"
  })));
}

/* harmony default export */ var star_yellow_ratings = (SvgStarYellowRatings);
// EXTERNAL MODULE: ./components/homepage-v2/customer-says/testimonial-card/TestimonialCardV2.module.scss
var TestimonialCardV2_module = __webpack_require__(59125);
var TestimonialCardV2_module_default = /*#__PURE__*/__webpack_require__.n(TestimonialCardV2_module);
;// CONCATENATED MODULE: ./components/homepage-v2/customer-says/testimonial-card/TestimonialCardV2.tsx




var TestimonialCardV2 = function(param) {
    var quote = param.quote, name = param.name, role = param.role, initials = param.initials;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (TestimonialCardV2_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestimonialCardV2_module_default()).stars,
                "aria-hidden": "true",
                children: Array.from({
                    length: 5
                }).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(star_yellow_ratings, {
                        className: (TestimonialCardV2_module_default()).starIcon
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (TestimonialCardV2_module_default()).quote,
                children: quote
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TestimonialCardV2_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TestimonialCardV2_module_default()).avatar,
                        children: initials
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (TestimonialCardV2_module_default()).meta,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (TestimonialCardV2_module_default()).name,
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (TestimonialCardV2_module_default()).role,
                                children: role
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var testimonial_card_TestimonialCardV2 = (TestimonialCardV2);

;// CONCATENATED MODULE: ./components/homepage-v2/customer-says/testimonials.json
var testimonials_namespaceObject = JSON.parse('[{"quote":"My experience with Vahak was excellent and I am very satisfied. The truck arrived on time, transparent pricing, no hidden cost and secure transactions. I would definitely recommend people to go for their service.","name":"Mohammed Ibrahim","role":"Shipper","initials":"MI"},{"quote":"I never write reviews. But this Vahak app is helping my transport business. Other parties always delay balance payment, but here I placed my lorry and got balance payment same day after unloading. No fraud, very secure app.","name":"Jai Pal","role":"Lorry Owner","initials":"JP"},{"quote":"ऐप इस्तेमाल करने में बहुत आसान है। इनके लोग भी काफी मददगार हैं, पूरे सफर में हर चीज़ समझाई और साथ दिया। अच्छा और भरोसेमंद प्लेटफॉर्म है, मैं दूसरों को भी जरूर बताऊँगा।","name":"Chandru Swamy Chandru","role":"Shipper","initials":"CS"},{"quote":"Lorry bookings and dealing has never been easier. I just open the app and post my load and receive bids from the lorry owners directly. I can also use the lorry market feature to find a list of lorries available in the market.","name":"Joga Singh","role":"Load Owner","initials":"JS"},{"quote":"वाहक ऐप काम के लिए भरोसेमंद है। इस ऐप से पूरे देश में आसानी से माल भेज सकते हैं। इसे चलाने के लिए ज्यादा टेक्नोलॉजी जानने की जरूरत नहीं पड़ती। मैंने काफी ट्रांसपोर्टरों को लंबे समय से इसका इस्तेमाल करते देखा है।","name":"Aadhya Chawla","role":"Transporter","initials":"AC"},{"quote":"I\'ve been using this app for a while and it has truly proven to be a useful app for managing my bookings and appointments. The membership option offers a range of benefits and premium features that are well worth the booking amount.","name":"Vasim Khan","role":"Lorry Owner","initials":"VK"},{"quote":"Vahak is the best app for transport, whether for local or long-distance loads. Payments are cleared as soon as loading and unloading are completed, and the support team is always available to help anytime. Truly the best app — thank you, Vahak!","name":"Murugan K","role":"Shipper","initials":"MK"}]');
;// CONCATENATED MODULE: ./components/homepage-v2/customer-says/CustomerSaysSection.tsx










var TESTIMONIALS_SWIPER_BREAKPOINTS = {
    576: {
        slidesPerView: 2,
        spaceBetween: 24
    },
    992: {
        slidesPerView: 3,
        spaceBetween: 24
    }
};
var CustomerSaysSection = function() {
    var t = (0,useHomepageV2Translation/* default */.Z)().t;
    var swiperRef = (0,react.useRef)(null);
    var paginationRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (CustomerSaysSection_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                className: (CustomerSaysSection_module_default()).header,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (CustomerSaysSection_module_default()).eyebrow,
                        children: t("homepageV2:customerSays.eyebrow")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: (CustomerSaysSection_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CustomerSaysSection_module_default()).titleLine,
                                children: t("homepageV2:customerSays.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (CustomerSaysSection_module_default()).titleHighlight,
                                children: t("homepageV2:customerSays.titleHighlight")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2Animate/* default */.Z, {
                variant: "fade-up",
                delay: 120,
                className: (CustomerSaysSection_module_default()).carouselWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (CustomerSaysSection_module_default()).carouselShell,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (CustomerSaysSection_module_default()).prevBtn,
                            "aria-label": "Previous testimonial",
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slidePrev();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(angle_left/* default */.Z, {
                                "aria-hidden": true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: paginationRef,
                            className: (CustomerSaysSection_module_default()).dots
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (CustomerSaysSection_module_default()).swiperTrack,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swipper/* default */.Z, {
                                className: (CustomerSaysSection_module_default()).testimonialsSwiper,
                                cssMode: false,
                                loop: true,
                                navigation: false,
                                autoplay: {
                                    delay: 5000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true
                                },
                                slidesPerView: 1,
                                spaceBetween: 16,
                                breakpoints: TESTIMONIALS_SWIPER_BREAKPOINTS,
                                mousewheel: false,
                                paginationRef: paginationRef,
                                onSwiper: function(swiper) {
                                    swiperRef.current = swiper;
                                },
                                list: testimonials_namespaceObject.map(function(item) {
                                    return {
                                        key: item.name,
                                        node: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CustomerSaysSection_module_default()).slide,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(testimonial_card_TestimonialCardV2, {
                                                quote: item.quote,
                                                name: item.name,
                                                role: item.role,
                                                initials: item.initials
                                            })
                                        })
                                    };
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: (CustomerSaysSection_module_default()).nextBtn,
                            "aria-label": "Next testimonial",
                            onClick: function() {
                                var ref;
                                return (ref = swiperRef.current) === null || ref === void 0 ? void 0 : ref.slideNext();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(right_arrow/* default */.Z, {
                                "aria-hidden": true
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var customer_says_CustomerSaysSection = (CustomerSaysSection);

// EXTERNAL MODULE: ./components/homepage-v2/analytics/useWebV2Tracker.ts + 1 modules
var useWebV2Tracker = __webpack_require__(61782);
;// CONCATENATED MODULE: ./components/homepage-v2/HomepageV2.tsx
var ref;



















var IosLaunchBannerPopup = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6477).then(__webpack_require__.bind(__webpack_require__, 56477));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56477)
            ];
        }
    },
    ssr: false
});
var HOMEPAGE_META = {
    title: "Vahak — Book LCV in minutes",
    description: "Book LCVs and lorries online in minutes across India. ".concat(platformStats/* PLATFORM_STATS.transporters.verifiedShort */.s.transporters.verifiedShort, ", instant bids and live tracking on Vahak."),
    ogDescription: "Book LCVs and lorries online in minutes with ".concat(platformStats/* PLATFORM_STATS.transporters.verifiedShort */.s.transporters.verifiedShort, ", instant bids and zero middlemen."),
    ogImgSrc: "".concat(constants/* IMG_BASE_URL */.TSr, "/vahak-timeline_gvlxfa.png"),
    ogImgAltText: "Book LCV in minutes on Vahak with ".concat(platformStats/* PLATFORM_STATS.transporters.verifiedShort */.s.transporters.verifiedShort),
    ogType: "website",
    ogSiteName: "Vahak"
};
var HOMEPAGE_FAQ_LIST = (ref = constants/* FaqQuestions.filter */.DCW.filter(function(f) {
    return f.category === constants/* FaqSlugsConstant.GENERAL */.GB4.GENERAL;
})) === null || ref === void 0 ? void 0 : ref.flatMap(function(v) {
    return v.faqQuestions;
}).map(function(v) {
    return {
        question: v.question,
        answer: v.response
    };
});
var HomepageV2 = function() {
    var router = (0,next_router.useRouter)();
    var i18n = (0,useHomepageV2Translation/* default */.Z)().i18n;
    var ref = (0,CompactLoadPostingProvider/* useCompactLoadPosting */.S$)(), openCompactPosting = ref.openCompactPosting, isCompactPostingOpen = ref.isCompactPostingOpen, isCompactPostingOpening = ref.isCompactPostingOpening;
    var ref1 = (0,useWebV2Tracker/* useWebV2Tracker */.N)({
        sourceScreen: event_names/* WEB_V2_SOURCE_SCREENS.HOME_PAGE */.ZM.HOME_PAGE
    }), trackEvent = ref1.trackEvent, eventData = ref1.eventData;
    var onClickLoadBid = (0,useCompactLoadBidAction/* useCompactLoadBidAction */._)({
        trackEvent: trackEvent,
        eventData: eventData,
        preBidEventName: event_names/* GA4EventNames.WEB_V2.book_now */.wQ.WEB_V2.book_now
    }).onClickLoadBid;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                asPath: router.asPath,
                title: HOMEPAGE_META.title,
                description: HOMEPAGE_META.description,
                ogDescription: HOMEPAGE_META.ogDescription,
                ogImgSrc: HOMEPAGE_META.ogImgSrc,
                ogImgAltText: HOMEPAGE_META.ogImgAltText,
                ogType: HOMEPAGE_META.ogType,
                ogSiteName: HOMEPAGE_META.ogSiteName,
                includeDefaultSchema: false,
                schema: {
                    faqList: HOMEPAGE_FAQ_LIST,
                    extraJsonLd: {
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        name: constants/* COMPANY_DETAILS.name */.SXn.name,
                        url: constants/* COMPANY_DETAILS.website */.SXn.website,
                        potentialAction: {
                            "@type": "SearchAction",
                            target: "".concat(constants/* COMPANY_DETAILS.potentialActionTargetUrl */.SXn.potentialActionTargetUrl, "?q={search_term_string}"),
                            "query-input": "required name=search_term_string"
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IosLaunchBannerPopup, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (HomepageV2_module_default()).main,
                lang: i18n.language,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section_HeroSection, {
                        trackEvent: trackEvent,
                        eventData: eventData,
                        onOpenCompactPosting: openCompactPosting,
                        isCompactPostingOpen: isCompactPostingOpen,
                        isCompactPostingOpening: isCompactPostingOpening
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomepageV2_module_default()).contentStack,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
                                variant: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lorry_booking_steps_LorryBookingSteps, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(available_loads_section_AvailableLoadsSectionV2, {
                                trackEvent: trackEvent,
                                eventData: eventData,
                                onBidNow: onClickLoadBid
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownloadBannerV2/* default */.Z, {
                                trackEvent: trackEvent,
                                eventData: eventData
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomepageV2SectionCard/* default */.Z, {
                                variant: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_says_CustomerSaysSection, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var homepage_v2_HomepageV2 = (HomepageV2);

;// CONCATENATED MODULE: ./pages/index.tsx



var __N_SSG = true;
function Page() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(homepage_v2_HomepageV2, {});
};


/***/ }),

/***/ 68802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useGetLoadMarketInfiniteQueryNew; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26297);
/* harmony import */ var _vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37528);
/* harmony import */ var _vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36153);
/* harmony import */ var _vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41634);
/* harmony import */ var _queryNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9433);
/* harmony import */ var _vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46492);








var useGetLoadMarketInfiniteQueryNew = function(params, options) {
    var method = function method(param) {
        var _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
        var finalPreload = isAdmin ? preloads : preloads === null || preloads === void 0 ? void 0 : preloads.filter(function(val) {
            return val != "agent_details";
        });
        var payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, restParams), {
            page: pageParam,
            l: l,
            id: loadId,
            preloads: finalPreload
        });
        var urlString = (0,_vahak_core_dist_methods__WEBPACK_IMPORTED_MODULE_4__/* .generateQueryString */ .T9)(payload);
        return GET("".concat(_vahak_core_dist_services_const__WEBPACK_IMPORTED_MODULE_2__/* ["default"].LOAD_MARKET_V2_NEW */ .Z.LOAD_MARKET_V2_NEW).concat(urlString));
    };
    var page = params.page, l = params.l, preloads = params.preloads, isAdmin = params.isAdmin, loadId = params.loadId, restParams = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(params, [
        "page",
        "l",
        "preloads",
        "isAdmin",
        "loadId"
    ]);
    var GET = (0,_vahak_core_dist_hooks_useVahakHttpClient__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().GET;
    return (0,_vahak_core_dist_hooks_useVahakQueryClient__WEBPACK_IMPORTED_MODULE_0__/* .useVahakInfiniteQuery */ .xX)([
        _queryNames__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getLoadMarketInfiniteQueryV2 */ .Z.getLoadMarketInfiniteQueryV2,
        params
    ], method, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        getNextPageParam: function(lastPage, allPages) {
            var ref, ref1, ref2;
            if (((ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.page_number) < ((ref1 = lastPage.data) === null || ref1 === void 0 ? void 0 : ref1.total_pages)) return ((ref2 = lastPage.data) === null || ref2 === void 0 ? void 0 : ref2.page_number) + 1;
            return undefined;
        }
    }, options), {
        onSuccess: function(data) {
            var ref, ref1;
            var ref2;
            var aggregatedData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                total_pages: 0,
                total_records: 0,
                page_number: 0
            }, data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref[0]), {
                load_cards: data === null || data === void 0 ? void 0 : (ref1 = data.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap(function(page) {
                    var ref;
                    return (ref2 = page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.load_cards) !== null && ref2 !== void 0 ? ref2 : [];
                })
            });
            /**
             * Enclosing aggregatedData inside an array, just to fix the type script
             * as the onSuccess returns only aggregatedData[] - array type
             */ options.onSuccess([
                aggregatedData
            ]);
        },
        refetchOnWindowFocus: false
    }));
};


/***/ }),

/***/ 94136:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"HomepageV2_main__pBvIR","contentStack":"HomepageV2_contentStack__0E1ZG","hpv2HeroSlideIn":"HomepageV2_hpv2HeroSlideIn__M2DCn","hpv2HeroFadeIn":"HomepageV2_hpv2HeroFadeIn__HHieh","hpv2HeroFadeInOpacity":"HomepageV2_hpv2HeroFadeInOpacity__zCQ5k","hpv2FadeUp":"HomepageV2_hpv2FadeUp__17R1y","hpv2FadeLeft":"HomepageV2_hpv2FadeLeft__tHALa","hpv2FadeRight":"HomepageV2_hpv2FadeRight__tYmoV","hpv2ScaleUp":"HomepageV2_hpv2ScaleUp__i2V_o","hpv2Blink":"HomepageV2_hpv2Blink__cCsL_","hpv2FloatA":"HomepageV2_hpv2FloatA__pkEIA","hpv2FloatB":"HomepageV2_hpv2FloatB___uizi","hpv2DemoProgress":"HomepageV2_hpv2DemoProgress__lHtvU","hpv2DemoSlideIn":"HomepageV2_hpv2DemoSlideIn__cEZ_f","hpv2DemoFadeIn":"HomepageV2_hpv2DemoFadeIn__M9hc2","hpv2DemoScaleIn":"HomepageV2_hpv2DemoScaleIn__J_Eqv","hpv2DemoBounce":"HomepageV2_hpv2DemoBounce__4Nj5q","hpv2PulseDot":"HomepageV2_hpv2PulseDot__WXffQ","hpv2PriceShimmer":"HomepageV2_hpv2PriceShimmer__pn6wc"};

/***/ }),

/***/ 11528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerSaysSection_container__tKIna","header":"CustomerSaysSection_header__icXxu","eyebrow":"CustomerSaysSection_eyebrow__3_CPS","title":"CustomerSaysSection_title__83SGT","titleLine":"CustomerSaysSection_titleLine__OCwMq","titleHighlight":"CustomerSaysSection_titleHighlight__CmzyN","carouselWrapper":"CustomerSaysSection_carouselWrapper__c_dox","carouselShell":"CustomerSaysSection_carouselShell__fIX7B","swiperTrack":"CustomerSaysSection_swiperTrack__xfWic","testimonialsSwiper":"CustomerSaysSection_testimonialsSwiper__qvZ9F","slide":"CustomerSaysSection_slide___dyla","prevBtn":"CustomerSaysSection_prevBtn__HClGv","nextBtn":"CustomerSaysSection_nextBtn__Prp_3","dots":"CustomerSaysSection_dots__CXs0b","hpv2HeroSlideIn":"CustomerSaysSection_hpv2HeroSlideIn__zqYFy","hpv2HeroFadeIn":"CustomerSaysSection_hpv2HeroFadeIn___5yIj","hpv2HeroFadeInOpacity":"CustomerSaysSection_hpv2HeroFadeInOpacity__nA62E","hpv2FadeUp":"CustomerSaysSection_hpv2FadeUp__jJjHh","hpv2FadeLeft":"CustomerSaysSection_hpv2FadeLeft__7bpNS","hpv2FadeRight":"CustomerSaysSection_hpv2FadeRight__4vKsD","hpv2ScaleUp":"CustomerSaysSection_hpv2ScaleUp__u8cxJ","hpv2Blink":"CustomerSaysSection_hpv2Blink__CLVD3","hpv2FloatA":"CustomerSaysSection_hpv2FloatA__V65WN","hpv2FloatB":"CustomerSaysSection_hpv2FloatB__LyT3O","hpv2DemoProgress":"CustomerSaysSection_hpv2DemoProgress__D5qzp","hpv2DemoSlideIn":"CustomerSaysSection_hpv2DemoSlideIn__auyE8","hpv2DemoFadeIn":"CustomerSaysSection_hpv2DemoFadeIn__HgR_W","hpv2DemoScaleIn":"CustomerSaysSection_hpv2DemoScaleIn__u9aqJ","hpv2DemoBounce":"CustomerSaysSection_hpv2DemoBounce__y1Uvp","hpv2PulseDot":"CustomerSaysSection_hpv2PulseDot__IXRwy","hpv2PriceShimmer":"CustomerSaysSection_hpv2PriceShimmer__0QBuX"};

/***/ }),

/***/ 59125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"TestimonialCardV2_card__9hAgR","stars":"TestimonialCardV2_stars__vgS82","starIcon":"TestimonialCardV2_starIcon__GRX3o","quote":"TestimonialCardV2_quote__o_RTL","footer":"TestimonialCardV2_footer__GXNxR","avatar":"TestimonialCardV2_avatar__5R3nd","meta":"TestimonialCardV2_meta__P8GV7","name":"TestimonialCardV2_name__SGnzw","role":"TestimonialCardV2_role__CPrGg","hpv2HeroSlideIn":"TestimonialCardV2_hpv2HeroSlideIn__uwWzG","hpv2HeroFadeIn":"TestimonialCardV2_hpv2HeroFadeIn__pP4_g","hpv2HeroFadeInOpacity":"TestimonialCardV2_hpv2HeroFadeInOpacity__tUkT8","hpv2FadeUp":"TestimonialCardV2_hpv2FadeUp__53uJD","hpv2FadeLeft":"TestimonialCardV2_hpv2FadeLeft__JI7QC","hpv2FadeRight":"TestimonialCardV2_hpv2FadeRight__BqC5S","hpv2ScaleUp":"TestimonialCardV2_hpv2ScaleUp__gMcHf","hpv2Blink":"TestimonialCardV2_hpv2Blink__pneRg","hpv2FloatA":"TestimonialCardV2_hpv2FloatA__in9qr","hpv2FloatB":"TestimonialCardV2_hpv2FloatB__zEG1_","hpv2DemoProgress":"TestimonialCardV2_hpv2DemoProgress__tyHyj","hpv2DemoSlideIn":"TestimonialCardV2_hpv2DemoSlideIn__3cw0E","hpv2DemoFadeIn":"TestimonialCardV2_hpv2DemoFadeIn__zZjnZ","hpv2DemoScaleIn":"TestimonialCardV2_hpv2DemoScaleIn__rTthG","hpv2DemoBounce":"TestimonialCardV2_hpv2DemoBounce__tJbfQ","hpv2PulseDot":"TestimonialCardV2_hpv2PulseDot__TNGug","hpv2PriceShimmer":"TestimonialCardV2_hpv2PriceShimmer__HREAW"};

/***/ }),

/***/ 13073:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"HeroSection_section__OiLfB","container":"HeroSection_container__WBK0t","content":"HeroSection_content__lzD8l","left":"HeroSection_left__yJ3k_","hpv2HeroSlideIn":"HeroSection_hpv2HeroSlideIn__b0YmQ","eyebrow":"HeroSection_eyebrow__gTIrV","eyebrowSeparator":"HeroSection_eyebrowSeparator__Ygibb","title":"HeroSection_title__a_fRv","subtitle":"HeroSection_subtitle__BckvW","quoteFormWrap":"HeroSection_quoteFormWrap__o1DUj","hpv2HeroFadeIn":"HeroSection_hpv2HeroFadeIn__BBfkK","right":"HeroSection_right__OZfPD","hpv2HeroFadeInOpacity":"HeroSection_hpv2HeroFadeInOpacity__fq3Hz","truckFrame":"HeroSection_truckFrame__RwGd9","hpv2TruckDriveIn":"HeroSection_hpv2TruckDriveIn__iB5ms","truckBadge":"HeroSection_truckBadge__M8Xts","truckBadgeVerified":"HeroSection_truckBadgeVerified__OnWne","truckBadgeAvailable":"HeroSection_truckBadgeAvailable__ik0X3","badgeCheck":"HeroSection_badgeCheck__ZNvmg","badgeLive":"HeroSection_badgeLive__oPuHg","appDownload":"HeroSection_appDownload__eKQBE","appDownloadSeparator":"HeroSection_appDownloadSeparator__eVu8N","storeButtons":"HeroSection_storeButtons__jyiWF","storeButton":"HeroSection_storeButton__NGx5g","copy":"HeroSection_copy__TfKfx","hpv2FadeUp":"HeroSection_hpv2FadeUp__3z9qI","hpv2FadeLeft":"HeroSection_hpv2FadeLeft__Mf7Bf","hpv2FadeRight":"HeroSection_hpv2FadeRight__pAMKA","hpv2ScaleUp":"HeroSection_hpv2ScaleUp___G1kl","hpv2Blink":"HeroSection_hpv2Blink__U6rHq","hpv2FloatA":"HeroSection_hpv2FloatA__3TPRy","hpv2FloatB":"HeroSection_hpv2FloatB__HfRPU","hpv2DemoProgress":"HeroSection_hpv2DemoProgress__zkKVq","hpv2DemoSlideIn":"HeroSection_hpv2DemoSlideIn__79iIx","hpv2DemoFadeIn":"HeroSection_hpv2DemoFadeIn__KqzKM","hpv2DemoScaleIn":"HeroSection_hpv2DemoScaleIn__m_vb1","hpv2DemoBounce":"HeroSection_hpv2DemoBounce__8s8nG","hpv2PulseDot":"HeroSection_hpv2PulseDot__G331g","hpv2PriceShimmer":"HeroSection_hpv2PriceShimmer__ICuXa"};

/***/ }),

/***/ 30618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"QuoteFormCard_card__EU3GQ","fields":"QuoteFormCard_fields__FYIAY","cta":"QuoteFormCard_cta__l9Ja7","hpv2CtaGlow":"QuoteFormCard_hpv2CtaGlow__BeM64","ctaIcon":"QuoteFormCard_ctaIcon__dth6O","disclaimer":"QuoteFormCard_disclaimer__qtV4F","hpv2HeroSlideIn":"QuoteFormCard_hpv2HeroSlideIn__EwBf_","hpv2HeroFadeIn":"QuoteFormCard_hpv2HeroFadeIn__rbfJD","hpv2HeroFadeInOpacity":"QuoteFormCard_hpv2HeroFadeInOpacity__bchWp","hpv2FadeUp":"QuoteFormCard_hpv2FadeUp__zWer7","hpv2FadeLeft":"QuoteFormCard_hpv2FadeLeft__YJAFT","hpv2FadeRight":"QuoteFormCard_hpv2FadeRight__t0Izh","hpv2ScaleUp":"QuoteFormCard_hpv2ScaleUp__vzGh8","hpv2Blink":"QuoteFormCard_hpv2Blink__cccKV","hpv2FloatA":"QuoteFormCard_hpv2FloatA__MSQY_","hpv2FloatB":"QuoteFormCard_hpv2FloatB__VeM9a","hpv2DemoProgress":"QuoteFormCard_hpv2DemoProgress__OBxDx","hpv2DemoSlideIn":"QuoteFormCard_hpv2DemoSlideIn__Xj9oo","hpv2DemoFadeIn":"QuoteFormCard_hpv2DemoFadeIn__gBf1E","hpv2DemoScaleIn":"QuoteFormCard_hpv2DemoScaleIn__GZBmZ","hpv2DemoBounce":"QuoteFormCard_hpv2DemoBounce__OM_vR","hpv2PulseDot":"QuoteFormCard_hpv2PulseDot__bzFfS","hpv2PriceShimmer":"QuoteFormCard_hpv2PriceShimmer__t_ktf"};

/***/ }),

/***/ 56676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"LorryBookingSteps_container__jN_Lu","header":"LorryBookingSteps_header__lQqIi","eyebrow":"LorryBookingSteps_eyebrow__ga_7j","title":"LorryBookingSteps_title__36y4t","titleLine":"LorryBookingSteps_titleLine__TIO_v","titleHighlight":"LorryBookingSteps_titleHighlight__FiS4Z","grid":"LorryBookingSteps_grid__6Tnls","step":"LorryBookingSteps_step__cN6nT","stepHead":"LorryBookingSteps_stepHead__IG8cF","iconWrap":"LorryBookingSteps_iconWrap__OjgFr","stepNumber":"LorryBookingSteps_stepNumber__y6PPz","stepTitle":"LorryBookingSteps_stepTitle__VEnoK","stepDescription":"LorryBookingSteps_stepDescription__I5F1F","stepsSwiper":"LorryBookingSteps_stepsSwiper__n56pP"};

/***/ }),

/***/ 49256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"MarketplacePostingNudgeCard_main__4tvA0","textWrapper":"MarketplacePostingNudgeCard_textWrapper__TXajM"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5502,5829,1217,3128,2765,8416,5326,5755,9925,9616,4999,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);